import { useEffect, useState } from "react";
import ScrollReveal from "scrollreveal";
import { Card, Button, Badge } from '../ui';

const Agenda = () => {
  const [eventos] = useState([
    {
      titulo: "Horário Regular",
      descricao: "Todos os domingos às 13:30 (Inverno) e 14:30 (Verão).",
      badge: "Semanal",
      badgeVariant: "default"
    },
    {
      titulo: "Primeiro Domingo do Mês",
      descricao: "Culto de Santa Ceia - 13:30 (Inverno) e 14:30 (Verão).",
      badge: "Especial",
      badgeVariant: "success"
    },
    {
      titulo: "Localização",
      descricao: "Slachthuisweg 1B, 7556 AX Hengelo",
      link: "https://maps.app.goo.gl/7yiWFgyGFpCcaJ4J6",
      linkText: "Ver no Google Maps",
      badge: "Endereço",
      badgeVariant: "secondary"
    },
  ]);

  useEffect(() => {
    ScrollReveal().reveal(".reveal", {
      duration: 1000,
      distance: "50px",
      easing: "ease-in-out",
      origin: "bottom",
      reset: false,
    });
  }, []);

  return (
    <div
      id="agenda"
      className="agenda-container d-flex flex-column justify-content-center align-items-center py-5"
    >
      <h1 className="agenda-title text-center mb-5 reveal">Agenda do Mês</h1>

      <div className="container">
        <div className="row justify-content-center">
          {eventos.map((evento, index) => (
            <div key={index} className="col-md-6 col-lg-4 mb-4 reveal">
              <Card>
                <Card.Header>
                  <div className="d-flex justify-content-between align-items-center">
                    <h3 style={{ fontSize: '1.25rem', marginBottom: 0 }}>{evento.titulo}</h3>
                    <Badge variant={evento.badgeVariant} size="sm">{evento.badge}</Badge>
                  </div>
                </Card.Header>
                <Card.Body>
                  <p>{evento.descricao}</p>
                  {evento.link && (
                    <Button
                      onClick={() => window.open(evento.link, '_blank')}
                      variant="primary"
                      size="md"
                      className="w-100 mt-2"
                    >
                      <i className="bi bi-geo-alt-fill me-2"></i>
                      {evento.linkText}
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Agenda;
